import React from "react";
import styled from "styled-components";
import {
  LargeDevice,
  Mobile,
  SuperDesktop,
  NotSuperDesktop,
} from "../components/ReactResponsiveComponents";
import mediaQueries from "../constants/mediaQueries";
import breakpoints from "../constants/breakpoints";
import { Link } from "react-router-dom";

const BackContainer = styled.div`
  float: ${(props) => (props.direction === "left" ? `left` : `right`)};
  /* background: #2B4162  ; */
  background: white  ;
  width: 100%;
  margin-top: 1px; // Margem entre InfoBlocks
  user-select: none;
  @media ${mediaQueries.extraSmallDevices} {
    
  }
  @media ${mediaQueries.smallDevices} {

  }
  @media ${mediaQueries.mediumDevices} {
    padding-top: 20px;
  }
  @media ${mediaQueries.largeDevices} {
    padding-top: 20px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    padding-top: 20px;
  }
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  color:rgb(0, 100, 0);
  /* font-family: "Libre Franklin", sans-serif; */
  font-family: "Kanit", sans-serif;
  font-weight: 200;
  font-style: normal;
  white-space: pre-line;
  align-items: center;
  justify-content: center;
  @media ${mediaQueries.extraSmallDevices} {
    padding: 110px 20px 60px 20px;
  }
  @media ${mediaQueries.smallDevices} {
    padding: 110px 20px 40px 20px;
  }
  @media ${mediaQueries.mediumDevices} {
    padding: 40px 40px 40px 40px;
  }
  @media ${mediaQueries.largeDevices} {
    padding: 40px 40px 40px 40px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    padding: 40px 40px 40px 40px;
  }
`;

const DetailsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) =>
    props.direction === "left" ? `flex-start` : `flex-end`};
  @media ${mediaQueries.extraSmallDevices} {
    flex-direction: column;
  }
  @media ${mediaQueries.smallDevices} {
    flex-direction: column;
  }
  @media ${mediaQueries.mediumDevices} {
    flex-direction: row;
  }
  @media ${mediaQueries.largeDevices} {
    flex-direction: row;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    width: auto;
  }
`;

const TextContainer = styled.div`
  display: flex;
  @media ${mediaQueries.extraSmallDevices} {
    flex-direction: column;
  }
  @media ${mediaQueries.smallDevices} {
    flex-direction: column;
  }
  @media ${mediaQueries.mediumDevices} {
    flex-direction: column;
  }
  @media ${mediaQueries.largeDevices} {
    flex-direction: column;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    flex-direction: row;
  }
`;

const TextItem = styled.div`
  position: relative;
`;

const TDItem = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  @media ${mediaQueries.extraSmallDevices} {
    margin-right: 0px;
  }
  @media ${mediaQueries.smallDevices} {
    margin-right: 0px;
  }
  @media ${mediaQueries.mediumDevices} {
    margin-right: 20px;
    margin-left: 20px;
    width: 38vw;
  }
  @media ${mediaQueries.largeDevices} {
    margin-right: 20px;
    margin-left: 20px;
    width: 38vw;
    max-width: 600px;
    text-align: "left";
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    margin-right: 30px;
    margin-left: 30px;
    width: 35vw;
    /* text-align: ${(props) => (props.direction === "left" ? `left` : `right`)}; */
  }
`;

const Title = styled.div`
  position: absolute;
  width: 100%;
  font-weight: 500;
  @media ${mediaQueries.extraSmallDevices} {
    font-size: 18px;
    top: -30px;
    transform: translate(0%, -100%); // move pivot point
  }
  @media ${mediaQueries.smallDevices} {
    font-size: 20px;
    top: -30px;
    transform: translate(0%, -100%); // move pivot point
  }
  @media ${mediaQueries.mediumDevices} {
    font-size: 24px;
    top: -30px;
    transform: translate(0%, -100%); // move pivot point
  }
  @media ${mediaQueries.largeDevices} {
    font-size: 26px;
    top: -30px;
    transform: translate(0%, -100%); // move pivot point
    min-width: 500px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    font-size: 28px;
    top: -30px;
    transform: translate(0%, -100%); // move pivot point
  }
`;

const Description = styled.div`
  @media ${mediaQueries.extraSmallDevices} {
    font-size: 15px;
  }
  @media ${mediaQueries.smallDevices} {
    font-size: 17px;
  }
  @media ${mediaQueries.mediumDevices} {
    font-size: 18px;
  }
  @media ${mediaQueries.largeDevices} {
    font-size: 18px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    font-size: 20px;
  }
`;

const ImagesItem = styled.div`
  @media ${mediaQueries.extraSmallDevices} {
    margin-top: 20px;
    margin-right: 0px;
  }
  @media ${mediaQueries.smallDevices} {
    margin-top: 20px;
    margin-right: 0px;
  }
  @media ${mediaQueries.mediumDevices} {
    margin: ${(props) =>
      props.direction === "left" ? `0px 0px 0px 35px` : `0px 35px 0px 0px`};
  }
  @media ${mediaQueries.largeDevices} {
    margin: ${(props) =>
      props.direction === "left" ? `0px 0px 0px 35px` : `0px 35px 0px 0px`};
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    margin: ${(props) =>
      props.direction === "left" ? `0px 0px 0px 35px` : `0px 35px 0px 0px`};
  }
`;

const ImageItem1 = styled.div`
  @media ${mediaQueries.extraSmallDevices} {
    width: 100%;
  }
  @media ${mediaQueries.smallDevices} {
    width: 100%;
  }
  @media ${mediaQueries.mediumDevices} {
    width: 350px;
  }
  @media ${mediaQueries.largeDevices} {
    width: 450px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    width: 550px;
  }
`;

const ListContainer = styled.div`
  font-family: "DM Sans", sans-serif;
  font-weight: medium;
  @media ${mediaQueries.extraSmallDevices} {
    margin: 20px 0px 20px 0px;
  }
  @media ${mediaQueries.smallDevices} {
    margin: 20px 0px 20px 0px;
  }
  @media ${mediaQueries.mediumDevices} {
  }
  @media ${mediaQueries.largeDevices} {
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    border-left: 3px solid black;
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const List = styled.div`
  font-size: 14px;
  @media ${mediaQueries.largeDevices} {
    font-size: 14px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    font-size: 16px;
  }
`;

const ActionButton = styled.div`
  color: #eacab1;
  font-style: "DM Sans", "Druk", sans-serif;
  border-radius: 7px;
  text-decoration: underline;
  &:hover {
    color: #00373e;
    text-decoration: underline;
    cursor: pointer;
  }
  @media ${mediaQueries.extraSmallDevices} {
    font-size: 12px;
  }
  @media ${mediaQueries.smallDevices} {
    font-size: 14px;
  }
  @media ${mediaQueries.mediumDevices} {
    position: initial;
    align-self: ${(props) =>
      props.direction === "left" ? `flex-start` : `flex-end`};
    margin-top: 15px;
    margin-right: 20px;
    margin-left: 20px;
  }
  @media ${mediaQueries.largeDevices} {
    position: initial;
    align-self: ${(props) =>
      props.direction === "left" ? `flex-start` : `flex-end`};
    margin-top: 20px;
    margin-right: 20px;
    margin-left: 20px;
    font-size: 13px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    position: initial;
    align-self: ${(props) =>
      props.direction === "left" ? `flex-start` : `flex-end`};
    margin-top: 35px;
    margin-right: 0px;
    margin-left: 0px;
    font-size: 14px;
  }
`;

const RenderUnorderedList = (list) => {
  return (
    <ul style={{ listStylePosition: "inside" }}>
      {list.map((item) => (
        <li style={{ listStyleType: "circle" }}>{item}</li>
      ))}
    </ul>
  );
};

const InfoBlock = ({
  title,
  description,
  includes,
  imageURL,
  direction,
  button,
}) => {
  const RenderActionButton = (button) => {
    if (button !== undefined) {
      console.log(button);
      return (
        <ActionButton as={Link} to={button.link} direction={direction}>
          {button.name}
        </ActionButton>
      );
    }else{
      return <></>;
    }
  };
  const textElement = (
    <>
      <TextContainer>
        <TextItem>
          <TDItem direction={direction}>
            <Title>{title}</Title>
            <Description>{description}</Description>
            <SuperDesktop>{RenderActionButton(button)}</SuperDesktop>
          </TDItem>
        </TextItem>
        <TextItem>
          <ListContainer>
            <List>{RenderUnorderedList(includes)}</List>
          </ListContainer>
        </TextItem>

        <NotSuperDesktop>{RenderActionButton(button)}</NotSuperDesktop>
      </TextContainer>
    </>
  );
  const imageElement = (
    <>
      <ImagesItem direction={direction}>
        <ImageItem1 direction={direction}>
          <img width={"100%"} src={imageURL}></img>
        </ImageItem1>
      </ImagesItem>
    </>
  );

  if (direction === "left") {
    return (
      <BackContainer direction={direction}>
        <InfoContainer direction={direction}>
          <DetailsContainer direction={direction}>
            {textElement}
            {imageElement}
          </DetailsContainer>
        </InfoContainer>
      </BackContainer>
    );
  } else {
    return (
      <BackContainer direction={direction}>
        <InfoContainer direction={direction}>
          <DetailsContainer direction={direction}>
            <LargeDevice>
              {imageElement}
              {textElement}
            </LargeDevice>
            <Mobile>
              {textElement}
              {imageElement}
            </Mobile>
          </DetailsContainer>
        </InfoContainer>
      </BackContainer>
    );
  }
};

export default InfoBlock;
